<template>
  <div class="member-label-create">
    <el-form ref="form" :model="form" :rules="rules" hide-required-asterisk label-width="100px">
      <el-form-item label="标签名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入标签名称" class="input" />
      </el-form-item>
      <el-form-item label="标签描述" prop="description">
        <el-input type="textarea" rows="6" v-model="form.description" placeholder="请输入标签描述" show-word-limit />
      </el-form-item>
    </el-form>
    <div class="footer">
      <el-button @click="onBack" class="fun-btn mr20">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="onSubmit" class="fun-btn">确定</el-button>
    </div>
  </div>
</template>

<script>
import { api_putCreateLabel, api_postCreateLabel, api_getLabel } from '@/api/member'
export default {
  name: "mLabelCreate",
  data() {
    return {
      form: {
        description: '',
        name: ''
      },
      rules: {
        description: [{ required: true, message: '请输入标签描述' }],
        name: [{ required: true, message: '请输入标签名称' }],
      },
      submitLoading: false
    };
  },
  created() {
    if (this.$route.query.id) {
      this.$route.meta.breadcrumbTitle = '<span class="noblack">会员管理/会员标签<span class="black">/编辑标签</span></span>'
      this.getInfo()
    } else {
      this.$route.meta.breadcrumbTitle = '<span class="noblack">会员管理/会员标签<span class="black">/创建标签</span></span>'
    }
  },
  methods: {
    // 点击提交按钮
    onSubmit() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.submitLoading = true
          let params = {
            ...this.form,
          }
          try {
            this.$route.query.id ? await api_putCreateLabel({...params, id: this.$route.query.id}) : await api_postCreateLabel(params)
            this.$baseMessage('操作成功', 'success')
            this.onBack()
            this.submitLoading = false
          } catch {
            this.submitLoading = false
          }
        }
      })
    },
    // 获取详情数据
    async getInfo () {
      const data = await api_getLabel({id: this.$route.query.id})
      let {name, description} = data
      this.form = {name, description}
    },
    // 返回
    onBack() {
      this.$router.back(-1)
    },
  },
};
</script>

<style lang="scss" scoped>
.member-label-create {
  width: 100%;
  padding-top: 20px;
  box-sizing: border-box;
  position: relative;
  padding-bottom: 100px;
  .el-input,
  .el-textarea,
  .el-select {
    width: 350px;
  }

  .input-remark {
    height: 17px;
    line-height: 17px;
    font-size: 12px;
    color: #999999;
    position: absolute;
    left: 350px;
    bottom: 0;
  }

  .optional {
    height: 17px;
    line-height: 17px;
    margin-top: 5px;
    font-size: 12px;
    color: #666666;
  }
  ::v-deep{
    .avatar-uploader{
      height: 152px;
    }
  }

  .footer{
    position: fixed;
    bottom: 0;
    padding: 20px 0;
    padding-left: 70px;
    background: #fff;
    width: calc(100vw - #{$base-left-menu-width});
    left: $base-left-menu-width;
  }
}
</style>
